import { Card } from "antd";
import dayjs from "dayjs";

export const CheckInOutCard = ({ form }) => {
  const formatDate = (date) =>
    date ? dayjs(date).format("DD-MM-YYYY") : "—";

  const formatTime = (time) =>
    time ? dayjs(time, "HH:mm:ss").format("hh:mm A") : "—";

  const items = [
    {
      label: "Check-in",
      date: formatDate(form?.check_in),
      time: formatTime(form?.log_check_in_time),
    },
    {
      label: "Expected Check-out",
      date: formatDate(form?.check_out),
      time: formatTime(form?.log_check_out_time),
    },
  ];

  return (
    <>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
        {items.map(({ label, date, time }) => (
          <div
            key={label}
            style={{
              background: "#fafafa",
              borderRadius: 8,
              padding: "12px 14px",
            }}
          >
            <div
              style={{
                fontSize: 11,
                color: "#aaa",
                marginBottom: 6,
                textTransform: "uppercase",
                letterSpacing: "0.05em",
              }}
            >
              {label}
            </div>

            {/* {[["Date", date], ["Time", time]].map(([sub, val], i) => ( */}
            {[["Date", date]].map(([sub, val], i) => (
              <div
                key={sub}
                style={{
                  display: "flex",
                  alignItems: "baseline",
                  gap: 6,
                  ...(i > 0 && {
                    marginTop: 6,
                    paddingTop: 6,
                    borderTop: "0.5px solid #ebebeb",
                  }),
                }}
              >
                <span style={{ fontSize: 11, color: "#aaa", minWidth: 32 }}>
                  {sub}
                </span>
                <span
                  style={{
                    fontSize: 14,
                    fontWeight: 500,
                    color: "#1a1a1a",
                  }}
                >
                  {val}
                </span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </>
  );
};